import { render, staticRenderFns } from "./CrmOrderLost.vue?vue&type=template&id=01fa3db7&scoped=true"
import script from "./CrmOrderLost.vue?vue&type=script&lang=js"
export * from "./CrmOrderLost.vue?vue&type=script&lang=js"
import style0 from "./CrmOrderLost.vue?vue&type=style&index=0&id=01fa3db7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fa3db7",
  null
  
)

export default component.exports